import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { StatusMessage, Lottie } from '@hvcgroep/design-system';
import lottieHeat from '@hvcgroep/design-system/assets/lotties/warmte.json';
import lottieCosts from '@hvcgroep/design-system/assets/lotties/termijnbedrag.json';

import InfoBlock from '../../components/InfoBlock';
import Button from '../../../../shared/components/Button';
import { heatApi } from '../../store/slices/HeatApi';

type Props = {
  sjvGJ: string,
  ean: string,
  disableLottieReveal?: boolean;
  withExplanationLink?: boolean,
  onOpenPricingStructure?: () => void;
};

const OfferBlock: React.FC<Props> = (props) => {
  const {
    sjvGJ,
    ean,
    withExplanationLink = true,
    onOpenPricingStructure,
    disableLottieReveal,
  } = props;

  // Fetch the initial offer if there is none in the redux state yet.
  const { data: offer, status: offerStatus } = heatApi.endpoints.getOffer.useQuery({ ean, sjvGJ });
  const [trigger] = heatApi.endpoints.getOffer.useLazyQuerySubscription();

  const { t } = useTranslation();

  if (offerStatus === 'rejected' || !offer) {
    return (
      <StatusMessage type="error">
        <p className="mb-4">{t('registration_desk.server_errors.get_offer')}</p>
        <Button
          variation="center"
          onClick={() => trigger({ ean, sjvGJ })}
        >
          {t('registration_desk.buttons.retry')}
        </Button>
      </StatusMessage>
    );
  }

  function handleLottieReveal(animationSegments: [[number, number], [number, number]]) {
    if (disableLottieReveal) {
      return animationSegments.slice(1);
    }

    return animationSegments;
  }

  return (
    <div className="OfferBlock">
      <div className="OfferBlock__Info">
        <div className="row">
          <div className="col-6">
            <InfoBlock
              icon={(
                <Lottie
                  id="offer-block-heat-icon"
                  animationData={lottieHeat}
                  animationSegments={handleLottieReveal([[0, 114], [60, 114]])}
                  className="no-styling"
                />
              )}
              label={t('registration_desk.offer_block.heat.label')}
              title={`${offer.SJV}GJ`}
              subtitle={t('registration_desk.offer_block.heat.subtitle')}
            />
          </div>
          <div className="col-6">
            <InfoBlock
              icon={(
                <Lottie
                  id="offer-block-costs-icon"
                  animationData={lottieCosts}
                  animationSegments={handleLottieReveal([[0, 114], [60, 114]])}
                  className="no-styling"
                />
              )}
              label={t('registration_desk.offer_block.costs.label')}
              title={`€${offer.MonthAmount}`}
              subtitle={t('registration_desk.offer_block.costs.subtitle')}
              link={withExplanationLink && onOpenPricingStructure && (
                <button
                  type="button"
                  className="a no-styling mt-3"
                  onClick={() => onOpenPricingStructure()}
                >
                  {t('registration_desk.buttons.explanation')}
                </button>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferBlock;
